import React, {Component} from 'react'

import Screen from '../ui/Screen'

import TreeList from "./../ui/TreeList"
import ExpandState from "./../ui/ExpandState"
import ErrorMessageDialog from "./../ui/ErrorMessageDialog"

import ControlPanel from "./CategoryScreen/ControlPanel"
import CreateCategoryDialog from "./CategoryScreen/CreateCategoryDialog"
import CreateFolderDialog from "./CategoryScreen/CreateFolderDialog"
import EditCategoryDialog from "./CategoryScreen/EditCategoryDialog"
import EditFolderDialog from "./CategoryScreen/EditFolderDialog"
import DeleteCategoryDialog from "./CategoryScreen/DeleteCategoryDialog"
import DeleteFolderDialog from "./CategoryScreen/DeleteFolderDialog"

import Cookie from "../Cookie"
import {config} from "../config"

class CategoryScreen extends Component {

	constructor(props) {
		super(props)
		this.handleCreateFolder = this.handleCreateFolder.bind(this)
		this.handleCreateCategory = this.handleCreateCategory.bind(this)
		this.handleEditFolder = this.handleEditFolder.bind(this)
		this.handleEditCategory = this.handleEditCategory.bind(this)
		this.handleDeleteFolder = this.handleDeleteFolder.bind(this)
		this.handleDeleteCategory = this.handleDeleteCategory.bind(this)
		this.handleError = this.handleError.bind(this)
	}

	expandState = new ExpandState()

	state = {
		categorys: [],
		selected: undefined,
		dialog: undefined,
	}

	getCategorys() {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("GET", config.restApiHost + `/inventory/categorys?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)

						// получаем указатель на папку владельца
						let normalize = (items, parent) => {
							if (items) {
								for(let item of items) {
									item.parent = parent
									if (item.type === "0") {
										item.items = normalize(item.items, item)
									}
								}
							}
							return items
						}

						resolve(normalize(json, undefined))
					} else {
						reject("Не удалось получить список категорий")
					}
				}
			}
			xhr.send()
		})
	}

	findNewSelected(selected, categorys) {
		if (selected) {
			for(let c of categorys) {
				if (c.id === selected.id) {
					return c
				}
				if (c.type.toString() === "0") {
					let cc = this.findNewSelected(selected, c.items)
					if (cc) {
						return cc
					}
				}
			}
		}
	}

	update() {
		return new Promise((resolve, reject) => {
			this.getCategorys().then(categorys => {
				this.expandState.updateTree(categorys)
				this.setState({
					selected: this.expandSelectedParents(this.findNewSelected(this.state.selected, categorys)),
					categorys: categorys,
				}, resolve)
			}, reject)
		})
	}

	componentDidMount() {
		this.getCategorys().then(categorys => {
			this.setState({
				selected: undefined,
				categorys: categorys,
			})
		}, this.handleError)
	}

	createCategoryItem(item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("POST", config.restApiHost + `/inventory/category?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Не удалось создать папку или категорию")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send(JSON.stringify(item))
		})
	}

	updateCategoryItem(item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/inventory/category/${item.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Не удалось обновить папку или категорию")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send(JSON.stringify(item))
		})
	}

	deleteCategoryItem(item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("DELETE", config.restApiHost + `/inventory/category/${item.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Не удалось удалить папку или категорию")
					}
				}
			}
			xhr.send()
		})
	}

	handleError(errorMessage) {
		this.setState({
			dialog: <ErrorMessageDialog
				message = {errorMessage}
				onClose = {() => {
					this.update().then(() => {
						this.setState({
							dialog: undefined
						})
					}, this.handleError)
				}}
			/>
		})
	}

	handleCreateFolder() {
		this.setState({
			dialog: <CreateFolderDialog
				onCreateFolder = {folder => {
					let folderId = 0
					if (this.state.selected) {
						if (this.state.selected.type.toString() === "0") {
							folderId = this.state.selected.id
						} else {
							folderId = this.state.selected.folder_id
						}
					}
					this.createCategoryItem({
						name: folder.name,
						type: 0,
						folder_id: folderId,
						code: "",
					}).then(item => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleCreateCategory() {
		this.setState({
			dialog: <CreateCategoryDialog
				onCreateCategory = {category => {
					let folderId = 0
					if (this.state.selected) {
						if (this.state.selected.type.toString() === "0") {
							folderId = this.state.selected.id
						} else {
							folderId = this.state.selected.folder_id
						}
					}
					this.createCategoryItem({
						name: category.name,
						type: 1,
						folder_id: folderId,
						code: category.code,
					}).then(item => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleEditFolder(folder) {
		this.setState({
			dialog: <EditFolderDialog
				folder = {folder}
				onUpdateFolder = {folder => {
					this.updateCategoryItem(folder).then(() => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleEditCategory(category) {
		this.setState({
			dialog: <EditCategoryDialog
				category = {category}
				onUpdateCategory = {category => {
					this.updateCategoryItem(category).then(() => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleDeleteFolder(folder) {
		this.setState({
			dialog: <DeleteFolderDialog
				folder = {folder}
				onDeleteFolder = {folder => {
					this.deleteCategoryItem(folder).then(() => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						selected: undefined,
						dialog: undefined,
					})
				}}
			/>
		})
	}

	handleDeleteCategory(category) {
		this.setState({
			dialog: <DeleteCategoryDialog
				category = {category}
				onDeleteCategory = {category => {
					this.deleteCategoryItem(category).then(() => {
						this.update().then(() => {
							this.setState({
								selected: undefined,
								dialog: undefined,
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	expandSelectedParents(item) {
		let itm = item
		if (itm) {
			while(itm.parent) {
				itm.expand = true
				this.expandState.set(itm.id, itm.expand)
				itm = itm.parent
			}
		}
		return item
	}

	render() {

		return <Screen
			onClick = {e => {
				if (!this.state.dialog) {
					e.stopPropagation()
					this.setState({
						selected: undefined
					})
				}
			}}
		>

			{this.state.dialog}

			<ControlPanel
				selected = {this.state.selected}
				onCreateFolderClick = {this.handleCreateFolder}
				onCreateCategoryClick = {this.handleCreateCategory}
				onEditItemClick = {item => {
					if (item.type.toString() === "0") {
						this.handleEditFolder(item)
					}
					if (item.type.toString() === "1") {
						this.handleEditCategory(item)
					}
				}}
				onDeleteItemClick = {item => {
					if (item.type.toString() === "0") {
						this.handleDeleteFolder(item)
					}
					if (item.type.toString() === "1") {
						this.handleDeleteCategory(item)
					}
				}}
			/>

			<TreeList
				items = {this.state.categorys}
				selected = {this.state.selected}
				onClickItem = {category => {
					if (this.state.selected ? (this.state.selected.id === category.id) : false) {
						if (category.type === "0") { // dbl click folder
							category.expand = !category.expand
							this.expandState.set(category.id, category.expand)
							this.forceUpdate()
						} else { // dbl click category
							this.handleEditCategory(category)
						}
					} else {
						this.setState({
							selected: this.expandSelectedParents(category)
						})
					}
				}}
			/>

		</Screen>

	}

}

export default CategoryScreen
